import { Injectable, inject } from '@angular/core';
import { SharedFeatureConsentStateService } from './shared-feature-consent-state.service';
import { fromEvent, merge, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
/* eslint-disable @typescript-eslint/no-explicit-any */
declare const Cookiebot: any;

@Injectable({
  providedIn: 'root',
})
export class SharedFeatureCookieConsentService {
  private readonly consentState = inject(SharedFeatureConsentStateService);

  requestStorageAccess(): Observable<boolean> {
    if (this.consentState.hasUserMadeDecision()) {
      return of(this.consentState.hasAnyConsent());
    }

    if (typeof Cookiebot !== 'undefined') {
      Cookiebot.show();
    }

    return merge(
      fromEvent(window, 'CookiebotOnAccept').pipe(map(() => this.consentState.hasAnyConsent())),
      fromEvent(window, 'CookiebotOnDecline').pipe(map(() => false)),
    ).pipe(take(1));
  }
}
